<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">Codice</dt>
              <dd class="col-sm-9">{{profileData.code}}</dd>
              <dt class="col-sm-3">Titolo</dt>
              <dd class="col-sm-9">{{profileData.label}}</dd>
              <dt class="col-sm-3">Profilo dell'azienda</dt>
              <dd class="col-sm-9" v-if="profileData.company">
                <b-badge :variant="`warning`" class="mx-1">
                  <router-link class="cat" :to="{name: `companyShowRoute`, params:{id: profileData.company.id}}">
                    {{profileData.company.label}}
                  </router-link>
                </b-badge>
              </dd>
              <dt class="col-sm-3">Descrizione</dt>
              <dd class="col-sm-9">{{ profileData.description }}</dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button class="btn btn-danger float-right padder" variant="danger" @click="deleteModal = true"
                      type="button">
                {{ $t('actions.delete') }}
              </button>
              <router-link v-if="profileData.id" class="btn btn-primary float-right" role="button"
                           :to="{name: `profilesEditRoute`, params:{id: profileData.id}}" push>
                {{ $t('actions.edit') }}
              </router-link>
              <!-- Modal Component -->
              <b-modal title="Eliminazione del profilo" class="modal-danger" v-model="deleteModal" @ok="deleteProfile"
                       ok-variant="danger">
                {{ $t('page.generic.deleteMessage', {n: profileData.code}) }}
              </b-modal>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col lg="12" v-if="profileData.jsonData">
        <b-card title="JSON Data">
          <b-card-body>
            <b-tabs>
              <b-tab active>
                <template slot="title">
                  <i class="fal fa-table"></i>
                </template>
                <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
                         :small="small"
                         :fixed="fixed"
                         :sortBy="sortBy"
                         responsive="sm" :items="profileData.jsonData" :fields="captions"
                         :current-page="currentPage"
                         :per-page="perPage">
                  <template slot="value" slot-scope="data">
                    <span v-if="data.item.format !== 'base64'">{{ data.item.value }}</span>
                    <span v-else><img alt="Profile LOGO" style="max-height: 150px;"
                                      v-bind:src="'data:image/jpeg;base64,'+data.item.value"/></span>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                                next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-tab>
              <b-tab>
                <template slot="title">
                  <i class="fas fa-brackets-curly"></i>
                </template>
                <codemirror :value="jsonAsString" :options="cmOptions"></codemirror>
              </b-tab>
            </b-tabs>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="12" v-if="profileData.jsonXmlData">
        <b-card title="XML Data">
          <b-card-body>
            <codemirror :value="profileData.jsonXmlData" :options="cmOptionsTable2"></codemirror>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col lg="12" v-if="profileData.idTypeValues">
        <b-card title="Dati di configurazione del profilo">
          <b-card-body>
            <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
                     :small="small"
                     :fixed="fixed"
                     :sortBy="sortBy"
                     responsive="sm" :items="profileData.idTypeValues" :fields="captionsTable2"
                     :current-page="currentPageTable2"
                     :per-page="perPage">
            </b-table>
            <nav>
              <b-pagination :total-rows="totalRowsTable2" :per-page="perPage" v-model="currentPageTable2" prev-text="Prev"
                            next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import ProfileService from '@/services/ProfileService'
  import {codemirror} from 'vue-codemirror'
  // require styles
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/javascript/javascript.js'
  import 'codemirror/mode/xml/xml.js'
  import 'codemirror/addon/display/autorefresh.js'

  const profileService = ProfileService.build();

  export default {
    name: "ProfileShow",
    props: {
      id: {
        required: true
      },
      sortBy: {
        type: String,
        default: 'code'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      fields: {
        type: [Array, Object],
        default: () => [
          {key: 'code', label: 'Codice', sortable: true},
          {key: 'type', label: 'Tipo', sortable: true},
          {key: 'format', label: 'Formato', sortable: true},
          {key: 'value', label: 'Valore', sortable: true}
        ]
      },
      fieldsTable2: {
        type: [Array, Object],
        default: () => [
          {key: 'code', label: 'Codice', sortable: true},
          {key: 'idType.code', label: 'Codice Tipo', sortable: true},
          {key: 'description', label: 'Descrizione', sortable: true},
        ]
      },
      perPage: {
        type: Number,
        default: 10
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    components: {
      PageTitle,
      codemirror
    },
    data() {
      return {
        deleteModal: false,
        currentPage: 1,
        currentPageTable2: 1,
        profileData: {},
        cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'text/javascript',
          lineWrapping: true,
          theme: 'default',
          readOnly: 'nocursor',
          autoRefresh: true
        },
        cmOptionsTable2: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'application/xml',
          lineWrapping: true,
          theme: 'default',
          readOnly: 'nocursor'
        }
      }
    },
    computed: {
      totalRows: function () {
        return this.getRowCount()
      },
      totalRowsTable2: function () {
        return this.getRowCountTable2()
      },
      captions: function () {
        return this.fields
      },
      captionsTable2: function () {
        return this.fieldsTable2
      },
      jsonAsString: function () {
        if(this.profileData.jsonData) return JSON.stringify(this.profileData.jsonData, null, 4)
      },

    },
    created() {
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData();
    },
    methods: {
      getRowCount: function () {
        return this.profileData.jsonData ? this.profileData.jsonData.length : 0
      },
      getRowCountTable2: function () {
        return this.profileData.idTypeValues ? this.profileData.idTypeValues.length : 0
      },
      async fetchData() {
        try {
          this.profileData = await profileService.read(this.id)
        } catch (e) {
          miniToastr.error(e.message)
        }
      },
      async deleteProfile() {
        try {
          await profileService.destroy(this.id);
          this.$router.replace({path: '/profiles'});
          miniToastr.info("Profilo cancellato con successo!")
        } catch (exception) {
          miniToastr.error(exception.message)
        }
      }
    }
  }
</script>

<style scoped>
  .cat {
    text-underline: none !important;
    color: #000 !important;
  }

  .cat:hover {
    text-underline: none !important;
    color: #000 !important;
  }
</style>
